import {MantineColorScheme, MantineTheme} from "@mantine/core";

export function getPrimaryColor(theme: MantineTheme, scheme: MantineColorScheme) {
    return theme.colors[theme.primaryColor][scheme === 'light' ? 5 : 4];
}
